import React, { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";
import { MdDelete } from "react-icons/md";
import axios from "axios";
import CreateWarehouse from "./CreateWarehouse";
import EditWarehouse from "./EditWarehouse";
import {
  useGetWarehouseQuery,
  useRemoveWarehouseMutation,
} from "../../features/api/warehouseApi";

const Warehouse = () => {
  // get warehouse from custom hook
  // const [warehouses] = useWarehouse();
  const { data } = useGetWarehouseQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const warehouses = data?.warehouse;

  const [removeWarehouse] = useRemoveWarehouseMutation();
  const handleDelete = async (id) => {
    const confirm = window.confirm("Are Your Sure?");
    if (confirm) {
      try {
        const response = await removeWarehouse(id);

        if (response) {
          console.log(response);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <div className="px-12">
      <div className="flex justify-between items-center py-6">
        <h1 className="text-xl font-bold">Warehouse Management</h1>
        <CreateWarehouse />
      </div>
      <div className="">
        <TableContainer component={Paper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                  Sl No.
                </TableCell>
                <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                  Warehouse Name
                </TableCell>
                <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                  Location
                </TableCell>
                <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                  Address
                </TableCell>
                <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                  Mobile
                </TableCell>
                <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {warehouses
                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                ?.map((row, i) => (
                  <TableRow key={row.id}>
                    <TableCell>{i + 1}</TableCell>
                    <TableCell>{row?.wh_name}</TableCell>
                    <TableCell>{row?.wh_location}</TableCell>
                    <TableCell>{row?.wh_address}</TableCell>
                    <TableCell>{row?.wh_mobile}</TableCell>
                    <TableCell className="">
                      <div className="flex items-center gap-x-4">
                        <EditWarehouse house={row} />
                        {/* <span onClick={() => handleDelete(row?.id)}>
                          <MdDelete className="text-xl text-red-500 font-bold cursor-pointer" />
                        </span> */}
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          <TablePagination
            style={{ backgroundColor: "#f0f0f5" }}
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={warehouses?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>
      </div>
    </div>
  );
};

export default Warehouse;
